import { useNavigate, useParams } from 'react-router-dom'
import CenterService from '../../../../services/centers/center.service.js'
import CenterNavLinks from '../nav/CenterNavLinks.tsx'
import CenterTypeLinks from '../nav/CenterTypeLinks.tsx'
import AppContainer from '../../../../component/layout/AppContainer'
import { useEffect } from 'react'
import CenterSection from '../common/CenterSection'
import useInputs from '../../../../utils/hooks/useInputs.js'
import { mainCentersPathname } from '../../../../routes/centers/pathname.js'
import AppDateInput from '../../../../component/form/AppDateInput.tsx'
import EntityDropdown from '../../../../component/form/EntityDropdown.tsx'
import { Fieldset, Group, Stack, Table } from '@mantine/core'
import AppCheckbox from '../../../../component/form/AppCheckbox.tsx'
import AppButton from '../../../../component/common/AppButton.tsx'
import AppNumberFormatter from '../../../../component/data/AppNumberFormatter.tsx'
import AppInput from '../../../../component/form/AppInput.tsx'
import AppNumberInput from '../../../../component/form/AppNumberInput.tsx'
import { themeCfg } from '../../../../theme/theme.ts'
import AppSimpleGrid from '../../../../component/layout/AppSimpleGrid.tsx'
import { useTranslation } from 'react-i18next'
import AppToolbar from '../../../../component/layout/AppToolbar.tsx'

const CenterCashRegistersEdit = () => {
  const debug = false

  const { t } = useTranslation()

  const navigate = useNavigate()
  const { id } = useParams()
  const rowId = new URLSearchParams(window.location.search)?.get('id')

  const { inputs, onChangeInputs, updateInputs } = useInputs()

  useEffect(() => {
    getCenterCashRegisterData()
  }, [])

  const getCenterCashRegisterData = async () => {
    if (
      id &&
      id !== 'undefined' &&
      id !== '' &&
      rowId &&
      rowId !== 'undefined' &&
      rowId !== ''
    ) {
      const response = await CenterService?.cashRegisters?.getById({
        id,
        rowId,
      })
      if (response) {
        updateInputs(response.resp)
      }
    } else {
      const response = await CenterService?.cashRegisters?.getNewById({ id })
      if (response) {
        updateInputs(response.resp)
      }
    }
  }

  const handleSave = () => {
    const response = rowId
      ? CenterService.cashRegisters?.update({ id, rowId, body: inputs })
      : CenterService.cashRegisters?.create({
          id,
          body: { ...inputs, centerId: id },
        })
    if (response) navigate(mainCentersPathname.CASH_REGISTERS(id))
  }

  const handleDailySalesAdd = () => {
    const newDailySale = {
      saleTypeId: null,
      value: 0,
    }
    const dailySales = [...(inputs?.dailySales || []), newDailySale]
    updateInputs({ ...inputs, dailySales })
  }

  const handleExpensesAdd = () => {
    updateInputs({
      ...inputs,
      expenses: {
        expensesDetails: [
          ...(inputs?.expenses?.expensesDetails || []),
          { concept: null, value: 0 },
        ],
      },
    })
  }

  const handleOtherExpensesAdd = () => {
    updateInputs({
      ...inputs,
      otherExpenses: {
        cashMovementsDetails: [
          ...(inputs?.otherExpenses?.cashMovementsDetails || []),
          { ticket: null, value: 0 },
        ],
      },
    })
  }

  return (
    <CenterSection
      header={<CenterTypeLinks blur />}
      subheader={<CenterNavLinks id={id} />}
      mainContainer="scrollarea"
      toolbar={
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(mainCentersPathname.CASH_REGISTERS(id))}
            />,
            <AppButton preset="save" onClick={() => handleSave()} />,
          ]}
        />
      }
    >
      <AppSimpleGrid cols={1}>
        <AppContainer>
          <Stack>
            <AppSimpleGrid cols={2}>
              <Fieldset legend={t('date')}>
                <AppSimpleGrid cols={3}>
                  <AppDateInput
                    name="dailyStatus.date"
                    value={inputs?.dailyStatus?.date}
                    onChange={onChangeInputs}
                  />
                  <EntityDropdown
                    entity="weather"
                    name="dailyStatus.weather"
                    value={inputs?.dailyStatus?.weather}
                    onChange={onChangeInputs}
                  />
                  <AppCheckbox
                    size="lg"
                    labelh="closed"
                    name="dailyStatus.isClosed"
                    checked={inputs?.dailyStatus?.isClosed}
                    onChange={onChangeInputs}
                  />
                  {debug && JSON.stringify(inputs?.dailyStatus)}
                </AppSimpleGrid>
              </Fieldset>

              <Fieldset legend={t('sales')}>
                <AppSimpleGrid cols={2}>
                  <AppNumberInput
                    label="bancEntrance"
                    name="salesIncome.bancEntrance"
                    value={inputs?.salesIncome?.bancEntrance}
                    onChange={onChangeInputs}
                  />
                  <AppNumberInput
                    label="elephantTPV"
                    name="salesIncome.elephantTPV"
                    value={inputs?.salesIncome?.elephantTPV}
                    onChange={onChangeInputs}
                  />
                </AppSimpleGrid>
              </Fieldset>
            </AppSimpleGrid>

            <AppSimpleGrid cols={3}>
              <Fieldset legend={t('dailySales')}>
                <Table>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th w="60%">{t('saleType')}</Table.Th>
                      <Table.Th>{t('import')}</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {inputs?.dailySales?.map((dailySale, index) => (
                      <Table.Tr>
                        <Table.Td>
                          {dailySale?.saleTypeId || (
                            <EntityDropdown entity="salesType" />
                          )}
                        </Table.Td>
                        <Table.Td>
                          <AppNumberInput
                            name={`dailySales.${index}.value`}
                            value={dailySale?.value}
                            onChange={onChangeInputs}
                          />
                        </Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.Tbody>
                  <Table.Tfoot>
                    <Table.Tr>
                      <Table.Th fz="120%">{t('total')}</Table.Th>
                      <Table.Th
                        fz="120%"
                        style={{ textAlign: 'right' }}
                        pr={themeCfg?.default?.padding}
                      >
                        <Group
                          justify="flex-end"
                          c="primary"
                          px={themeCfg?.default?.padding}
                        >
                          <AppNumberFormatter
                            value={inputs?.dailySales?.reduce(
                              (total, dailySale) =>
                                total + (dailySale?.value || 0),
                              0,
                            )}
                          />
                        </Group>
                      </Table.Th>
                    </Table.Tr>
                    <Table.Tr>
                      <Table.Th></Table.Th>
                      <Table.Th style={{ textAlign: 'right' }}>
                        <AppButton preset="add" onClick={handleDailySalesAdd} />
                      </Table.Th>
                    </Table.Tr>
                  </Table.Tfoot>
                </Table>
                {debug && JSON.stringify(inputs?.dailySales)}
              </Fieldset>

              <Fieldset legend={t('trackSales')}>
                <Table>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th w="60%">{t('track')}</Table.Th>
                      <Table.Th>{t('import')}</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {inputs?.trackSales?.map((trackSale, index) => (
                      <Table.Tr>
                        <Table.Td>{trackSale?.num}</Table.Td>
                        <Table.Td>
                          <AppNumberInput
                            name={`trackSales.${index}.value`}
                            value={trackSale?.value}
                            onChange={onChangeInputs}
                          />
                        </Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.Tbody>
                  <Table.Tfoot>
                    <Table.Tr>
                      <Table.Th fz="120%">{t('total')}</Table.Th>
                      <Table.Th
                        fz="120%"
                        style={{ textAlign: 'right' }}
                        pr={themeCfg?.default?.padding}
                      >
                        <Group
                          justify="flex-end"
                          c="primary"
                          px={themeCfg?.default?.padding}
                        >
                          <AppNumberFormatter
                            value={inputs?.trackSales?.reduce(
                              (total, trackSale) =>
                                total + (trackSale?.value || 0),
                              0,
                            )}
                          />
                        </Group>
                      </Table.Th>
                    </Table.Tr>
                  </Table.Tfoot>
                </Table>
                {debug && JSON.stringify(inputs?.trackSales)}
              </Fieldset>

              <Fieldset legend={t('aspiratorSales')}>
                <Table>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th w="60%">{t('aspirator')}</Table.Th>
                      <Table.Th>{t('import')}</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {inputs?.aspiratorSales?.map((aspiratorSale, index) => (
                      <Table.Tr>
                        <Table.Td>{aspiratorSale?.num}</Table.Td>
                        <Table.Td>
                          <AppNumberInput
                            name={`aspiratorSales.${index}.value`}
                            value={aspiratorSale?.value}
                            onChange={onChangeInputs}
                          />
                        </Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.Tbody>
                  <Table.Tfoot>
                    <Table.Tr>
                      <Table.Th fz="120%">{t('total')}</Table.Th>
                      <Table.Th
                        fz="120%"
                        style={{ textAlign: 'right' }}
                        pr={themeCfg?.default?.padding}
                      >
                        <Group
                          justify="flex-end"
                          c="primary"
                          px={themeCfg?.default?.padding}
                        >
                          <AppNumberFormatter
                            value={inputs?.aspiratorSales?.reduce(
                              (total, aspiratorSale) =>
                                total + (aspiratorSale?.value || 0),
                              0,
                            )}
                          />
                        </Group>
                      </Table.Th>
                    </Table.Tr>
                  </Table.Tfoot>
                </Table>
                {debug && JSON.stringify(inputs?.aspiratorSales)}
              </Fieldset>
            </AppSimpleGrid>

            <AppSimpleGrid cols={2}>
              <Fieldset legend={t('expenses')}>
                <Table>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th w="60%">{t('concept')}</Table.Th>
                      <Table.Th>{t('import')}</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {inputs?.expenses?.expensesDetails?.map(
                      (expense, index) => (
                        <Table.Tr>
                          <Table.Td>
                            <EntityDropdown
                              entity="expense"
                              name={`expenses.expensesDetails.${index}.concept`}
                              value={expense?.concept}
                              onChange={onChangeInputs}
                            />
                          </Table.Td>
                          <Table.Td>
                            <AppNumberInput
                              name={`expenses.expensesDetails.${index}.value`}
                              value={expense?.value}
                              onChange={onChangeInputs}
                            />
                          </Table.Td>
                        </Table.Tr>
                      ),
                    )}
                  </Table.Tbody>
                  <Table.Tfoot fz="120%" fw="bolder">
                    <Table.Tr>
                      <Table.Th>{t('total')}</Table.Th>
                      <Table.Th
                        style={{ textAlign: 'right' }}
                        pr={themeCfg?.default?.padding}
                      >
                        <Group
                          justify="flex-end"
                          c="primary"
                          px={themeCfg?.default?.padding}
                        >
                          <AppNumberFormatter
                            value={inputs?.expenses?.expensesDetails?.reduce(
                              (total, expense) => total + (expense?.value || 0),
                              0,
                            )}
                          />
                          {/* backend value? */}
                          {/* {inputs?.expenses?.total} */}
                        </Group>
                      </Table.Th>
                    </Table.Tr>
                    <Table.Tr>
                      <Table.Th></Table.Th>
                      <Table.Th style={{ textAlign: 'right' }}>
                        <AppButton preset="add" onClick={handleExpensesAdd} />
                      </Table.Th>
                    </Table.Tr>
                  </Table.Tfoot>
                </Table>
                {debug && JSON.stringify(inputs?.expenses?.expensesDetails)}
              </Fieldset>

              <Fieldset legend={t('otherExpenses')}>
                <Table>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th w="60%">{t('ticket')}</Table.Th>
                      <Table.Th>{t('import')}</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {inputs?.otherExpenses?.cashMovementsDetails?.map(
                      (otherExpense, index) => (
                        <Table.Tr>
                          <Table.Td>
                            <AppInput
                              name={`otherExpenses.cashMovementsDetails.${index}.ticket`}
                              value={otherExpense?.ticket}
                              onChange={onChangeInputs}
                            />
                          </Table.Td>
                          <Table.Td>
                            <AppNumberInput
                              name={`otherExpenses.cashMovementsDetails.${index}.value`}
                              value={otherExpense?.value}
                              onChange={onChangeInputs}
                            />
                          </Table.Td>
                        </Table.Tr>
                      ),
                    )}
                  </Table.Tbody>
                  <Table.Tfoot fz="120%" fw="bolder">
                    <Table.Tr>
                      <Table.Th>{t('total')}</Table.Th>
                      <Table.Th
                        style={{ textAlign: 'right' }}
                        pr={themeCfg?.default?.padding}
                      >
                        <Group
                          justify="flex-end"
                          c="primary"
                          px={themeCfg?.default?.padding}
                        >
                          <AppNumberFormatter
                            value={inputs?.otherExpenses?.cashMovementsDetails?.reduce(
                              (total, otherExpense) =>
                                total + (otherExpense?.value || 0),
                              0,
                            )}
                          />
                          {/* backend value? */}
                          {/* {inputs?.expenses?.total} */}
                        </Group>
                      </Table.Th>
                    </Table.Tr>
                    <Table.Tr>
                      <Table.Th></Table.Th>
                      <Table.Th style={{ textAlign: 'right' }}>
                        <AppButton
                          preset="add"
                          onClick={handleOtherExpensesAdd}
                        />
                      </Table.Th>
                    </Table.Tr>
                  </Table.Tfoot>
                </Table>
                {debug && JSON.stringify(inputs?.otherExpenses)}
              </Fieldset>
            </AppSimpleGrid>

            <AppSimpleGrid cols={2}>
              <Fieldset legend={t('salesIncome')}>
                <Group>
                  <AppNumberInput
                    label={t('bancEntrance')}
                    value={inputs?.salesIncome?.bancEntrance}
                    onChange={onChangeInputs}
                    name="salesIncome.bancEntrance"
                  />
                  <AppNumberInput
                    label={t('elephantTPV')}
                    value={inputs?.salesIncome?.elephantTPV}
                    onChange={onChangeInputs}
                    name="salesIncome.elephantTPV"
                  />
                </Group>
                {debug && JSON.stringify(inputs?.salesIncome)}
              </Fieldset>

              <Fieldset legend={t('freebies')}>
                <Group>
                  <AppNumberInput
                    label={t('trackCleaning')}
                    value={inputs?.freebies?.trackCleaning}
                    onChange={onChangeInputs}
                    name="freebies.trackCleaning"
                  />
                  <AppNumberInput
                    label={t('promotions')}
                    value={inputs?.freebies?.promotions}
                    onChange={onChangeInputs}
                    name="freebies.promotions"
                  />
                  <AppNumberInput
                    label={t('deliveryEmployeeCards')}
                    value={inputs?.freebies?.deliveryEmployeeCards}
                    onChange={onChangeInputs}
                    name="freebies.deliveryEmployeeCards"
                  />
                  <AppNumberInput
                    label={t('customerComplaints')}
                    value={inputs?.freebies?.customerComplaints}
                    onChange={onChangeInputs}
                    name="freebies.customerComplaints"
                  />
                </Group>
                {debug && JSON.stringify(inputs?.salesIncome)}
              </Fieldset>
            </AppSimpleGrid>

            <AppSimpleGrid cols={2}>
              <Fieldset legend={t('billing')}>
                <Group>
                  <AppNumberInput
                    label={t('consumptionClientsAlreadyBilled')}
                    value={inputs?.billing?.ConsumptionClientsAlreadyBilled}
                    onChange={onChangeInputs}
                    name="billing.ConsumptionClientsAlreadyBilled"
                  />
                  <AppNumberInput
                    label={t('customerInvoiceRequests')}
                    value={inputs?.billing?.customerInvoiceRequests}
                    onChange={onChangeInputs}
                    name="billing.customerInvoiceRequests"
                  />
                  <AppNumberInput
                    label={t('creditSales')}
                    value={inputs?.billing?.creditSales}
                    onChange={onChangeInputs}
                    name="billing.creditSales"
                  />
                </Group>
                {debug && JSON.stringify(inputs?.billing)}
              </Fieldset>

              <Fieldset legend={t('totals')}>
                <Group w="100%" justify="space-between" align="flex-end">
                  <Group w="100%">
                    <Table>
                      <Table.Tbody>
                        <Table.Tr>
                          <Table.Td>{t('tracks')}</Table.Td>
                          <Table.Td fw="bolder" fz="120%">
                            <AppNumberFormatter
                              value={inputs?.totals?.tracks}
                            />
                          </Table.Td>
                        </Table.Tr>
                        <Table.Tr>
                          <Table.Td>{t('aspirators')}</Table.Td>
                          <Table.Td fw="bolder" fz="120%">
                            <AppNumberFormatter
                              value={inputs?.totals?.aspirators}
                            />
                          </Table.Td>
                        </Table.Tr>
                        <Table.Tr>
                          <Table.Td>{t('sales')}</Table.Td>
                          <Table.Td fw="bolder" fz="120%">
                            <AppNumberFormatter value={inputs?.totals?.sales} />
                          </Table.Td>
                        </Table.Tr>
                        <Table.Tr fw="bolder">
                          <Table.Td fz="120%">
                            {t('theoreticalCashBalance')}
                          </Table.Td>
                          <Table.Td fz="120%" fw="bolder">
                            <AppNumberFormatter
                              value={inputs?.totals?.theoreticalCashBalance}
                            />
                          </Table.Td>
                        </Table.Tr>
                      </Table.Tbody>
                    </Table>
                    {debug && JSON.stringify(inputs?.totals)}
                  </Group>

                  <Stack w="100%" justify="space-between">
                    {/* <AppNumberInput label={t("pulses")} value={inputs?.totals?.pulses} name="totals.pulses" onChange={onChangeInputs} /> */}
                    <AppNumberInput
                      className={
                        inputs?.totals?.theoreticalCashBalance !==
                        inputs?.totals?.cashBalance
                          ? 'text-error'
                          : 'text-success'
                      }
                      size="xl"
                      label={t('cashBalance')}
                      value={inputs?.totals?.cashBalance}
                      name="totals.cashBalance"
                      onChange={onChangeInputs}
                    />
                  </Stack>
                </Group>
              </Fieldset>
            </AppSimpleGrid>

            {debug && JSON.stringify(inputs?.totals)}
          </Stack>
        </AppContainer>
      </AppSimpleGrid>
    </CenterSection>
  )
}

export default CenterCashRegistersEdit
